import React, { useState } from "react";
import "./LicensePage.css";
import logo from "./logo.png"; // <-- put your logo here

export default function LicensePage() {
  const [licenseKey, setLicenseKey] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const formatKey = (value: string) => {
    const cleaned = value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
    const parts = cleaned.match(/.{1,4}/g);
    return parts ? parts.join("-").substring(0, 19) : "";
  };

  const validateKey = (key: string) => {
    return /^[A-Z0-9]{4}(-[A-Z0-9]{4}){3}$/.test(key);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateKey(licenseKey)) {
      setStatus("error");
      setMessage("Invalid license key format.");
      return;
    }

    try {
      setStatus("loading");

      const res = await fetch("/api/validate-license", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ licenseKey }),
      });

      const data = await res.json();

      if (data.valid) {
        setStatus("success");
        setMessage("License activated successfully!");
      } else {
        setStatus("error");
        setMessage(data.message || "License key is invalid.");
      }
    } catch {
      setStatus("error");
      setMessage("Server error. Please try again.");
    }
  };

  return (
    <div className="page">
      <div className="card">
        <img src="https://estore-kenya.netlify.app/static/media/logo.add17d5d8ae6531cfa77.png" alt="Logo" className="logo" />

        <h2>Activate Your License</h2>

        <form onSubmit={handleSubmit} className="form">
          <input
            type="text"
            value={licenseKey}
            onChange={(e) => setLicenseKey(formatKey(e.target.value))}
            placeholder="XXXX-XXXX-XXXX-XXXX"
            maxLength={19}
          />

          <button type="submit" disabled={status === "loading"}>
            {status === "loading" ? "Validating..." : "Activate"}
          </button>
        </form>

        {status === "success" && <p className="success">{message}</p>}
        {status === "error" && <p className="error">{message}</p>}
      </div>
    </div>
  );
}
